module.exports = __webpack_public_path__ + "img/winnings-napi.5d0c3988.png";